



















































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AccountModule from '@/store/modules/Account';
import GeneralModule from '@/store/modules/General';
import AuthModule from '@/store/modules/Auth';
import CreateAccountData from '@/data/CreateAccount';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import ManageMixin from '@/mixins/Manage.vue';
import UserData from '@/data/User';

@Component
export default class EditAgentView extends Mixins(ErrorHandleMixin, ManageMixin) {
  AccountInstance = getModule(AccountModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  mainKey = 0;

  selected: any = {};

  ptSubAgent: any = '';

  authPt: any = '';

  beforeMount() {
    const { user } = this.$router.currentRoute.params;
    if (!user) this.$router.go(-1);
  }

  async created() {
    const { user } = this.$router.currentRoute.params;
    const subAgentId = this.AuthInstance.user._id;
    this.ptSubAgent = await this.AccountInstance.FetchPtSubAgent({
      subAgent: subAgentId,
    });
    this.selected = user;
    this.selected.role = 'AGENT';
    this.createPt();
  }

  async createPt() {
    if (this.AuthInstance.user.role !== 'SUBAGENT') {
      this.authPt = this.AuthInstance.user.pt.general;
    } else {
      this.authPt = this.ptSubAgent;
    }
  }

  alert(res) {
    const { code } = res;
    if (code === 0) {
      this.modalData = {
        profile: UserData.initialUserInfo(),
        lock: UserData.initialLock(),
        password: UserData.initialPassword(),
        pt: UserData.initialPT(),
        refill: UserData.initialRefill(),
        deduct: UserData.initialDeduct(),
      };
    }
    this.modal = UserData.initialModal();
    this.checkError(res);
  }

  async onSubmit() {
    this.GeneralInstance.toggleLoading(true);
    const { code, message } = await this.AccountInstance.CreateAccount(this.selected);
    this.GeneralInstance.toggleLoading(false);
    if (code === 0) {
      this.selected = CreateAccountData.initialUserData();
      this.mainKey += 1;
    }
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });
  }

  editPT(user) {
    this.currentSelectUser = user._id;
    this.modal.pt = true;
  }

  async submitEditPT() {
    const params = {
      userId: this.currentSelectUser,
      pt: {
        before: this.selected.pt.general,
        after: this.modalData.pt.general / 100,
      },
    };
    const res = await this.AccountInstance.UpdateCommission(params);
    this.selected.pt.general = this.modalData.pt.general / 100;
    this.alert(res);
  }
}
